module.exports = "/shifts/components/subNavigation-70ac6e.html";